/**
 * 邀请码相关工具函数
 */

const INVITE_CODE_KEY = "invite_code";

/**
 * 从 URL 中获取邀请码参数
 * 支持两种格式：
 * 1. 查询参数: ?invite=CODE 或 #/?invite=CODE
 * 2. 路径参数: /ic/CODE 或 #/ic/CODE (HashRouter)
 * @returns 邀请码或 null
 */
export const getInviteCodeFromUrl = (): string | null => {
  if (typeof window === "undefined") return null;

  const hash = window.location.hash;
  console.log(hash, "hash");
  // 1. 从 hash 中的路径参数获取 #/ic/:code
  if (hash) {
    const hashPathMatch = hash.match(/#\/ic\/([^\/\?]+)/);
    if (hashPathMatch && hashPathMatch[1]) {
      console.log("从 Hash 路径参数获取到邀请码:", hashPathMatch[1]);
      return hashPathMatch[1];
    }

    // 2. 从 hash 中的查询参数获取 #/?invite=code 或 #/mining?invite=code
    const hashQueryMatch = hash.match(/[?&]invite=([^&]+)/);
    if (hashQueryMatch && hashQueryMatch[1]) {
      console.log("从 Hash 查询参数获取到邀请码:", hashQueryMatch[1]);
      return hashQueryMatch[1];
    }
  }

  // 3. 兼容旧版：从路径参数获取 /ic/:code (BrowserRouter)
  const pathMatch = window.location.pathname.match(/\/ic\/([^\/]+)/);
  if (pathMatch && pathMatch[1]) {
    console.log("从路径参数获取到邀请码:", pathMatch[1]);
    return pathMatch[1];
  }

  // 4. 兼容旧版：从查询参数获取 ?invite=code
  const urlParams = new URLSearchParams(window.location.search);
  const inviteParam = urlParams.get("invite");
  if (inviteParam) {
    console.log("从查询参数获取到邀请码:", inviteParam);
    return inviteParam;
  }

  return null;
};

/**
 * 保存邀请码到 localStorage（用于后续登录）
 * @param inviteCode - 邀请码
 */
export const saveInviteCode = (inviteCode: string) => {
  localStorage.setItem(INVITE_CODE_KEY, inviteCode);
};

/**
 * 获取已保存的邀请码
 * @returns 邀请码或 null
 */
export const getSavedInviteCode = (): string | null => {
  return localStorage.getItem(INVITE_CODE_KEY);
};

/**
 * 清除保存的邀请码
 */
export const clearInviteCode = () => {
  localStorage.removeItem(INVITE_CODE_KEY);
};

/**
 * 生成邀请链接（HashRouter 模式）
 * @param inviteCode - 邀请码
 * @returns 完整的邀请链接
 */
export const generateInviteLink = (inviteCode: string): string => {
  if (typeof window === "undefined") return "";

  const baseUrl = window.location.origin;
  // HashRouter 模式下使用 #/ic/:code
  return `${baseUrl}/#/ic/${inviteCode}`;
};
